import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faChevronDown, faChevronLeft, faEnvelope } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, CircularProgress, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { sxCircularProgressCenter, sxDarkGreyBody, sxMenuItem, sxSubTitle } from "../../../../../assets/styles/CommonSxProps";
import { StepMotivoProps } from "../../../../../interfaces/props/Cancelamento/StepMotivoProps";
import { sxContactButton, sxSelect } from "../sxProps";
import './styles.css';
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import DefaultButton from "../../../../../components/Accessibility/DefaultButton";
import FilterSelect from "../../../../../components/FilterSelect";

const StepMotivoCancelamento: React.FC<StepMotivoProps> = ({
  motivosCancelamento, onProceed, backStep, goToEmailStep, toggleMotivoSelecionado, fetchMotivosCancelamento, loading
}) => {

  const { textStyleAccessibility } = useAccessibility();
  const accessibility = useAccessibility();
  const [motivoSelecionado, setMotivoSelecionado] = useState<string>('');
  const [tipoCancelamentoSelecionado, setTipoCancelamentoSelecionado] = useState<string>('');
  const [jaPossuiMotivo, setJaPossuiMotivo] = useState<boolean>(false);

  useEffect(() => {
    if (motivosCancelamento !== undefined && !jaPossuiMotivo) {
      if (motivosCancelamento.tipoCancelamento !== null && motivosCancelamento.tipoCancelamento !== '') {
        setTipoCancelamentoSelecionado(motivosCancelamento.tipoCancelamento);
        setJaPossuiMotivo(true);
        fetchMotivosCancelamento(motivosCancelamento.tipoCancelamento)
      }
    }
  }, [])

  const handleSelectMotivo = (e: SelectChangeEvent) => {
    const idMotivo = e.target.value;
    toggleMotivoSelecionado(idMotivo);
    setMotivoSelecionado(idMotivo);
  };

  const handleSelectTipoCancelamento = (e: SelectChangeEvent) => {
    const idTipoCancel = e.target.value;
    fetchMotivosCancelamento(idTipoCancel);
    setTipoCancelamentoSelecionado(idTipoCancel);
  };

  const handleClickWhatsApp = () => {
    const whatsappUrl = motivosCancelamento?.emailWhatsApp.linkWhatsApp;
    window.open(whatsappUrl, '_blank');
  }

  const handleClickEmail = () => {
    goToEmailStep();
  }

  return (
    <div className="motivo-cancelamento-container">
      <>
        {!!motivosCancelamento?.lstTipoCancelamento.length &&
          <div className="flex-column">
            <Typography style={textStyleAccessibility} sx={sxSubTitle}>
              Quais beneficiários você deseja cancelar?
            </Typography>
            <InputLabel
                id='quais-beneficiarios-label'
                style={{
                  position: 'absolute',
                  width: '1px',
                  height: '1px',
                  margin: '-1px',
                  padding: '0',
                  border: '0',
                  overflow: 'hidden',
                  clip: 'rect(0 0 0 0)',
                  whiteSpace: 'nowrap',
                }}
            >Quais beneficiários você deseja cancelar?</InputLabel>
              <Select
                id='desejaCancelar'
                labelId='quais-beneficiarios-label'
                sx={sxSelect}
                style={textStyleAccessibility}
                value={tipoCancelamentoSelecionado}
                placeholder="Selecione"
                onChange={(e) => handleSelectTipoCancelamento(e)}
                IconComponent={(props) => <FontAwesomeIcon style={{ color: accessibility.contrastMode ? 'white' : '' }} icon={faChevronDown} {...props} />}
                disabled={jaPossuiMotivo}
              >
                {!!motivosCancelamento.lstTipoCancelamento.length &&
                  motivosCancelamento.lstTipoCancelamento.map((tipoCancel) => (
                    tipoCancel.descr && <MenuItem key={tipoCancel.id} sx={sxMenuItem} value={tipoCancel.id}>{tipoCancel.descr}</MenuItem>
                  ))
                }
              </Select>
          </div>
        }
        <div className="flex-column">
          <Typography style={textStyleAccessibility} sx={sxSubTitle}>
            Motivo do cancelamento
          </Typography>
          <InputLabel
            id='motivo-label'
            style={{
              position: 'absolute',
              width: '1px',
              height: '1px',
              margin: '-1px',
              padding: '0',
              border: '0',
              overflow: 'hidden',
              clip: 'rect(0 0 0 0)',
              whiteSpace: 'nowrap',
            }}
          >Motivo do cancelamento</InputLabel>
            <Select
              sx={sxSelect}
              labelId='motivo-label'
              style={textStyleAccessibility}
              value={motivoSelecionado}
              disabled={!!motivosCancelamento?.lstTipoCancelamento.length && !tipoCancelamentoSelecionado}
              placeholder="Selecione"
              onChange={(e) => handleSelectMotivo(e)}
              IconComponent={(props) => <FontAwesomeIcon style={{ color: accessibility.contrastMode ? 'white' : '' }} icon={faChevronDown} {...props} />}
            >
              {!!motivosCancelamento?.listaMotivoCancel.length &&
                motivosCancelamento.listaMotivoCancel.map((motivoCancel, index) => (
                  motivoCancel.descr && <MenuItem key={index} sx={sxMenuItem} value={motivoCancel.id}>{motivoCancel.descr}</MenuItem>
                ))
              }
            </Select>
        </div>
      </>
      {motivoSelecionado !== "" && motivosCancelamento?.emailWhatsApp.isEmailWhatsApp &&
        <>
          <Typography style={textStyleAccessibility} sx={sxSubTitle}>
            Continue aproveitando todos os benefícios de ser cliente Unimed Campinas!
          </Typography>
          <Typography style={textStyleAccessibility} sx={sxDarkGreyBody} maxWidth={'640px'}>
            Converse com um de nossos especialistas pelos canais abaixo:
          </Typography>
          <div className="cancellation-contact-buttons-holder">
            <Button
              variant="outlined"
              size="large"
              sx={sxContactButton}
              style={{ borderColor: accessibility.contrastMode ? accessibility.contrastColor : '' }}
              onClick={handleClickEmail}
            >
              <div className="button-icon-label">
                <FontAwesomeIcon icon={faEnvelope} style={{ ...accessibility.contrastColorAccessibility, color: '#00995D' }} />
                <Typography style={{ ...textStyleAccessibility, color: '#00995D' }}>E-MAIL</Typography>
              </div>
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={sxContactButton}
              style={{ borderColor: accessibility.contrastMode ? accessibility.contrastColor : '' }}
              onClick={handleClickWhatsApp}
            >
              <div className="button-icon-label">
                <FontAwesomeIcon icon={faWhatsapp} style={{ ...accessibility.contrastColorAccessibility, color: '#00995D' }} />
                <Typography style={{ ...textStyleAccessibility, color: '#00995D' }}>WHATSAPP</Typography>
              </div>
            </Button>
          </div>
        </>
      }
      <div className='cancellation-buttons-container'>
        <DefaultButton
          onClick={onProceed}
          text="Prosseguir"
          disabled={!motivoSelecionado}
        />
        <button style={{ ...textStyleAccessibility }} className="back-button" onClick={backStep} aria-label="Voltar para menu">
          <FontAwesomeIcon style={textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
        </button>
      </div>
    </div>
  )
}

export default StepMotivoCancelamento;